var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"no-gutter":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" Copyright ⓒ BusinessOn Communication Co., Ltd. All rights reserved. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }